import { SERVICE_CARD_TEXTS, SERVICES_KEYS } from "appLauncher";
import styled from "styled-components";

const BannerBg = styled.div`
  width: 100%;
  background-image: url(/assets/product/banner.png);
  background-position: center;
  margin-left: 50%;
  transform: translateX(-50%);
`;

const BannerWrapper = styled.div`
  min-height: 220px;
  border-radius: 16px;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 32px 40px;
  box-sizing: border-box;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  background: none;
`;

const Left = styled.div`
  width: 640px;
`;

const Title = styled.h1`
  font-size: 30px;
  font-weight: 800;
  color: #2640ed;
  margin-bottom: 16px;
`;

const Detail = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #1b2532;
  margin-bottom: 16px;
  line-height: 26px;
`;

const TagGroup = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  white-space: nowrap;
`;

const Tag = styled.span`
  background: none;
  color: #1b2532;
  border-radius: 999px;
  padding: 4px 16px 4px 8px;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
`;

const ApplyButton = styled.button`
  background: #2640ed;
  color: #fff;
  border: none;
  border-radius: 0;
  padding: 10px 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  vertical-align: middle;
  &:hover {
    background: #1b2e99;
  }
`;

const Right = styled.div`
  width: 204px;
  min-width: 204px;
  height: 276px;
  background: #fff;
  border-radius: 7px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-left: 20px;
`;

const OptionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

const OptionItem = styled.li<{ selected?: boolean }>`
  width: 100%;
  height: 36px;
  line-height: 36px;
  padding: 0 32px;
  border-radius: 0;
  background: ${({ selected }) => (selected ? "#e3eefd" : "none")};
  color: ${({ selected }) => (selected ? "#2640ed" : "#666666")};
  font-size: 15px;
  font-weight: ${({ selected }) => (selected ? 600 : 400)};
  cursor: pointer;
  border: none;
  margin-bottom: 0;
  transition: background 0.2s;
  position: relative;
  &::before,
  &::after {
    content: "";
    display: ${({ selected }) => (selected ? "block" : "none")};
    position: absolute;
    top: 8px;
    bottom: 8px;
    width: 3px;
    background: #2640ed;
    border-radius: 2px;
  }
  &::before {
    left: 0;
  }
  &::after {
    right: 0;
  }
`;

import { FIXED_TAGS } from "appLauncher";
const PRODUCT_OPTIONS = SERVICES_KEYS.map((label) => ({
  label,
  detail: SERVICE_CARD_TEXTS[label],
}));

export default function Banner({
  selected,
  setSelected,
}: {
  selected: number;
  setSelected: Function;
}) {
  const current = PRODUCT_OPTIONS[selected];

  return (
    <BannerBg>
      <BannerWrapper>
        <Left>
          <Title>{current.label}</Title>
          <Detail>{current.detail}</Detail>
          <TagGroup>
            {FIXED_TAGS.map((tag, i) => (
              <Tag key={tag}>
                <img src={"/assets/product/i-" + (i + 1) + ".png"} />
                {tag}
              </Tag>
            ))}
          </TagGroup>
          <ApplyButton>
            立即申请
            <svg
              width="22"
              height="16"
              viewBox="0 0 22 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="2"
                y1="8"
                x2="20"
                y2="8"
                stroke="#fff"
                strokeWidth="2"
              />
              <polyline
                points="14,3 20,8 14,13"
                stroke="#fff"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ApplyButton>
        </Left>
        <Right>
          <OptionList>
            {PRODUCT_OPTIONS.map((opt, idx) => (
              <OptionItem
                key={opt.label}
                selected={selected === idx}
                onClick={() => setSelected(idx)}
              >
                {opt.label}
              </OptionItem>
            ))}
          </OptionList>
        </Right>
      </BannerWrapper>
    </BannerBg>
  );
}
